import { Chip } from '@mui/material';
import {
  HourglassEmpty,
  Warning,
  Error,
  CheckCircle,
  Cancel
} from '@mui/icons-material';
import { StatoScadenza } from '../../types/scadenza.types';

interface StatusChipProps {
  stato: StatoScadenza;
  size?: 'small' | 'medium';
}

const statusConfig = {
  [StatoScadenza.ATTIVA]: {
    label: 'Attiva',
    color: '#1976d2' as const,
    icon: HourglassEmpty
  },
  [StatoScadenza.IN_SCADENZA]: {
    label: 'In Scadenza',
    color: '#E67700' as const, // WCAG AA compliant (contrast ratio 4.51:1)
    icon: Warning
  },
  [StatoScadenza.SCADUTA]: {
    label: 'Scaduta',
    color: '#d32f2f' as const,
    icon: Error
  },
  [StatoScadenza.COMPLETATA]: {
    label: 'Completata',
    color: '#0D8A7F' as const, // WCAG AA compliant (contrast ratio 4.50:1)
    icon: CheckCircle
  },
  [StatoScadenza.ANNULLATA]: {
    label: 'Annullata',
    color: '#757575' as const, // Darkened for better contrast (contrast ratio 4.54:1)
    icon: Cancel
  }
};

const StatusChip: React.FC<StatusChipProps> = ({ stato, size = 'small' }) => {
  const config = statusConfig[stato];
  const Icon = config.icon;

  return (
    <Chip
      icon={<Icon sx={{ color: config.color + ' !important' }} />}
      label={config.label}
      size={size}
      sx={{
        backgroundColor: config.color + '20',
        color: config.color,
        fontWeight: 600,
        borderColor: config.color,
        '& .MuiChip-icon': {
          color: config.color
        }
      }}
    />
  );
};

export default StatusChip;
